/* eslint-disable linebreak-style */
import React from 'react';

const chainlinkIcon = (
    fill: string,
    size: number,
    style?: React.CSSProperties,
) => (
    <svg
        id="Layer_2"
        data-name="Layer 2"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size * 1.153916}
        viewBox="0 0 24 27.694"
        style={style}
    >
        <title>chainlink icon</title>
        <g id="Layer_1" data-name="Layer 1">
            <path
                id="Path_176"
                data-name="Path 176"
                d="M12,0,9.46,1.461l-6.921,4L0,6.923V20.77l2.54,1.461,6.984,4,2.54,1.461,2.54-1.461,6.857-4L24,20.77V6.923L21.46,5.463l-6.921-4ZM5.079,17.848v-8l6.921-4,6.921,4v8L12,21.85Z"
                fill={fill || '#2A5ADA'}
            />
        </g>
    </svg>
);
export default chainlinkIcon;
